import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@feature/utils';

import { MobilityForm } from './MobilityForm';
import { useMobilityCreate } from './model/MobilityQuery';
import { MobilitySchema, defaultMobilityValues, mobilitySchema, toMobilityRequest } from './model/MobilitySchema';

export function MobilityCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useMobilityCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: MobilitySchema) =>
    mutate(toMobilityRequest(values), {
      onError: notification.error,
      onSuccess: newMobility => {
        notification.success();
        navigate({ to: '/author/mobility/$mobilityId', params: { mobilityId: String(newMobility.id) } });
      },
    });

  return (
    <MobilityForm
      title={t('mobilities.form.title.create')}
      schema={mobilitySchema}
      defaultValues={defaultMobilityValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
